<template>
  <tiles>
    <card-component title="Bestand" icon="safe" class="tile is-child">
      <b-table
        v-if="hasPermission('vault.list')"
        :data="data"
        :loading="loading"
        paginated
        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        aria-next-label="Nächste Seite ->"
        aria-previous-label="<- Vorherige Seite"
        aria-page-label="Seite"
        aria-current-label="Aktuelle Seite"
        backend-sorting
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"
      >
        <b-table-column label="ID" field="id" sortable v-slot="props">
          {{ props.row.id }}
        </b-table-column>
        <b-table-column label="Produkt" field="product" v-slot="props">
          {{ props.row.product }}
        </b-table-column>
        <b-table-column label="Menge" field="amount" sortable v-slot="props">
          {{
            props.row.amount.toLocaleString('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 5,
              maximumFractionDigits: 5,
            })
          }}
        </b-table-column>
        <b-table-column label="Wert" field="price" sortable v-slot="props">
          {{
            props.row.price.toLocaleString('de-DE', {
              style: 'currency',
              currency: 'EUR',
            })
          }}
        </b-table-column>
        <b-table-column
          v-if="hasPermission('order.create')"
          custom-key="actions"
          cell-class="is-actions-cell"
          v-slot="props"
        >
          <div class="buttons is-right">
            <b-button
              v-if="props.row.product_sendable"
              :disabled="props.row.amount < 1"
              @click="
                $router.push(
                  '/order/shipping/' + customerId + '/' + props.row.id,
                )
              "
              class="button"
              type="button"
            >
              <b-icon icon="truck-delivery-outline" /><span>Versenden</span>
            </b-button>
            <b-button
              :disabled="props.row.amount <= 0"
              @click="
                $router.push(
                  '/order/purchase/' + customerId + '/' + props.row.id,
                )
              "
              class="button"
              type="button"
            >
              <b-icon icon="cart-arrow-up" /><span>Verkaufen</span>
            </b-button>
          </div>
        </b-table-column>

        <section slot="empty" class="section">
          <div class="content has-text-grey has-text-centered">
            <template v-if="loading">
              <p>
                <b-icon icon="dots-horizontal" size="is-large" />
              </p>
              <p>Lade Daten...</p>
            </template>
            <template v-else>
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
              <p>Keine Daten vorhanden&hellip;</p>
            </template>
          </div>
        </section>
      </b-table>
    </card-component>
  </tiles>
</template>
<script>
import { oaxios } from '@/_helpers'

import CardComponent from '@/components/CardComponent'
import Tiles from '@/components/Tiles'
import { mapGetters } from 'vuex'

export default {
  name: 'vault-list',
  components: {
    CardComponent,
    Tiles,
  },
  props: {
    customerId: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      data: [],
      total: 0,
      loading: false,
      sortField: 'id',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 15,
    }
  },
  computed: {
    ...mapGetters('permission', ['hasPermission']),
  },
  methods: {
    loadAsyncData() {
      if (this.hasPermission('vault.list')) {
        this.loading = true
        const data = {
          customer_id: this.customerId,
          sort_field: this.sortField,
          sort_order: this.sortOrder,
        }

        oaxios(`/vault/list?page=${this.page}`, data)
          .then((r) => {
            this.data = r.data.data
            this.total = r.data.meta.total
            this.perPage = r.data.meta.per_page
          })
          .catch(() => {
            this.data = []
            this.total = 0
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    onPageChange(page) {
      this.page = page
      this.loadAsyncData()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadAsyncData()
    },
  },
  filters: {
    /**
     * Filter to truncate string, accepts a length parameter
     */
    truncate(value, length) {
      return value.length > length ? value.substr(0, length) + '...' : value
    },
  },
  mounted() {
    this.loadAsyncData()
  },
}
</script>
